(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() {
    super();
    this.isProductPage = true
  }

  hide() {
    super.hide(this.isProductPage);
    window.pauseAllMedia();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();    
  }

  showActiveMedia() {
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
    }
    if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-animation-section"] && !Shopify.designMode) return;
  try {
    
class PinnedAnimationSection {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId || container.id;
    this.animationInitialized = false;
    this.init();
  }

  init() {
    // Initialize with a slight delay to ensure DOM is ready
    setTimeout(() => {
      this.loadAndSetup();
    }, this.isInEditor() ? 500 : 300);
  }

  isInEditor() {
    return document.body.classList.contains('shopify-design-mode') || 
           document.body.classList.contains('shopify-editor-activated');
  }

  async loadAndSetup() {
    // Prevent double initialization
    if (this.animationInitialized) return;
    
    try {
      await this.loadLibraries();
      this.setupAnimation();
      this.animationInitialized = true;
    } catch (error) {
      console.warn('Pinned Animation: Failed to load GSAP, using native animations');
      this.setupNativeAnimation();
    }
  }

  async loadLibraries() {
    const scripts = [];
    
    // Load GSAP if not already loaded
    if (typeof gsap === 'undefined') {
      scripts.push(
        this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js')
      );
    }
    
    // Load ScrollTrigger if not already loaded
    if (typeof ScrollTrigger === 'undefined') {
      scripts.push(
        this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/ScrollTrigger.min.js')
      );
    }
    
    // Wait for essential scripts to load
    if (scripts.length > 0) {
      await Promise.all(scripts);
    }
    
    // Small delay to ensure scripts are fully executed
    await new Promise(resolve => setTimeout(resolve, 100));
  }

  loadScript(src) {
    return new Promise((resolve, reject) => {
      // Check if script is already loaded
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      
      const script = document.createElement('script');
      script.src = src;
      
      const timeoutId = setTimeout(() => {
        reject(new Error(`Script load timeout: ${src}`));
      }, 10000);
      
      script.onload = () => {
        clearTimeout(timeoutId);
        resolve();
      };
      
      script.onerror = (error) => {
        clearTimeout(timeoutId);
        reject(error);
      };
      
      document.head.appendChild(script);
    });
  }

  setupAnimation() {
    // Clean up any existing instances
    this.cleanup();
    
    try {
      // Check if GSAP is available
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        this.setupGsapAnimation();
      } else {
        this.setupNativeAnimation();
      }
      this.animationInitialized = true;
    } catch (error) {
      console.error('Pinned Animation: Error setting up animations:', error);
      this.setupSimpleFallback();
    }
  }

  // Replace the setupGsapAnimation() method with this updated version:

setupGsapAnimation() {
  const pinnedSection = this.container.querySelector('.pinned-anim-section');
  const gridCardsWrapper = this.container.querySelector('.grid-cards');
  const gridCards = gridCardsWrapper?.querySelectorAll('.grid-card');
  const textContainers = this.container.querySelectorAll('.text-container');
  
  if (!pinnedSection || !gridCards || gridCards.length === 0) {
    this.setupNativeAnimation();
    return;
  }
  
  // Check if mobile
  const isMobile = window.innerWidth <= 767;
  
  if (isMobile) {
    this.setupMobileLayout();
    return;
  }
  
  const numCards = gridCards.length;
  
  // Register plugins
  gsap.registerPlugin(ScrollTrigger);
  
  // Set card heights (like in Codepen)
  this.setCardHeights(gridCardsWrapper, gridCards);
  
  // Main scroll trigger EXACTLY like Codepen
  this.mainScrollTrigger = ScrollTrigger.create({
    trigger: pinnedSection,
    start: 'top top',
    end: `${window.innerHeight * numCards}px`,
    pin: true,
    scrub: true,
    onUpdate: ({progress}) => {
      // Set CSS variable like in Codepen
      gridCardsWrapper.style.setProperty('--progress', progress);
    },
    invalidateOnRefresh: true
  });
  
  // Card animation EXACTLY like Codepen
  this.cardAnimation = gsap.to(gridCards, {
    yPercent: (numCards - 1) * -100,
    ease: 'none',
    scrollTrigger: {
      trigger: pinnedSection,
      start: 'top top',
      end: `${window.innerHeight * numCards - 200}px`,
      snap: {
        snapTo: progress => {
          const cardIndex = Math.round(progress * (numCards - 1));
          return cardIndex / (numCards - 1);
        },
        ease: 'power4.out',
        duration: 0.5,
        delay: 0.1,
      },
      scrub: true,
      invalidateOnRefresh: true
    }
  });
  
  // Background parallax EXACTLY like Codepen
  const bgImage = this.container.querySelector('.background-pinned-parallax img');
  if (bgImage) {
    this.bgAnimation = gsap.fromTo(bgImage, {
      y: 0,
    }, {
      y: -200,
      scrollTrigger: {
        trigger: pinnedSection,
        start: 'top top',
        end: `${window.innerHeight * numCards - 100}px`,
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  }
  
  // Text animations
  this.setupTextAnimations(pinnedSection, textContainers, numCards);
  
  // Refresh ScrollTrigger after setup
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500);
}

// Add this new method for mobile layout:
setupMobileLayout() {
  const pinnedSection = this.container.querySelector('.pinned-anim-section');
  const gridCards = this.container.querySelectorAll('.grid-card');
  const textContainers = this.container.querySelectorAll('.text-container');
  
  // Reset any existing transforms
  pinnedSection.style.position = 'relative';
  pinnedSection.style.height = 'auto';
  pinnedSection.style.minHeight = '100vh';
  
  // Show all cards stacked
  gridCards.forEach(card => {
    card.style.transform = 'none';
    card.style.height = 'auto';
    card.style.minHeight = '150px';
  });
  
  // Show only first text container
  textContainers.forEach((container, index) => {
    container.style.position = 'relative';
    container.style.opacity = index === 0 ? '1' : '0';
    container.style.transform = 'none';
    container.style.height = 'auto';
    container.style.minHeight = '50vh';
    container.style.display = index === 0 ? 'flex' : 'none';
  });
  
  // Clean up any GSAP animations on mobile
  if (this.cardAnimation) this.cardAnimation.kill();
  if (this.bgAnimation) this.bgAnimation.kill();
  if (this.mainScrollTrigger) this.mainScrollTrigger.kill();
  if (this.textScrollTrigger) this.textScrollTrigger.kill();
  
  // Remove pin-spacer if exists
  const pinSpacer = this.container.querySelector('.pin-spacer');
  if (pinSpacer) {
    pinSpacer.style.display = 'none';
  }
}

// Update the cleanup method to handle mobile properly:
cleanup() {
  // Kill GSAP animations
  if (typeof gsap !== 'undefined') {
    if (this.cardAnimation) this.cardAnimation.kill();
    if (this.bgAnimation) this.bgAnimation.kill();
    if (this.mainScrollTrigger) this.mainScrollTrigger.kill();
    if (this.textScrollTrigger) this.textScrollTrigger.kill();
  }
  
  // Remove pin-spacer
  const pinSpacer = this.container.querySelector('.pin-spacer');
  if (pinSpacer) {
    pinSpacer.remove();
  }
  
  // Reset mobile styles
  const pinnedSection = this.container.querySelector('.pinned-anim-section');
  if (pinnedSection) {
    pinnedSection.style.position = '';
    pinnedSection.style.height = '';
    pinnedSection.style.minHeight = '';
  }
  
  // Remove event listeners
  if (this.scrollListener) {
    window.removeEventListener('scroll', this.scrollListener);
  }
  if (this.resizeListener) {
    window.removeEventListener('resize', this.resizeListener);
  }
  
  this.animationInitialized = false;
}

// Update the setupAnimation method to check for mobile:
setupAnimation() {
  // Clean up any existing instances
  this.cleanup();
  
  try {
    // Check if mobile
    const isMobile = window.innerWidth <= 767;
    
    if (isMobile) {
      this.setupMobileLayout();
    } else {
      // Check if GSAP is available
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        this.setupGsapAnimation();
      } else {
        this.setupNativeAnimation();
      }
    }
    this.animationInitialized = true;
  } catch (error) {
    console.error('Pinned Animation: Error setting up animations:', error);
    this.setupSimpleFallback();
  }
}

  setCardHeights(wrapper, cards) {
    // Function exactly like in Codepen
    let biggerHeight = 0;
    cards.forEach(card => {
      const newHeight = card.getBoundingClientRect().height;
      if (newHeight > biggerHeight) {
        biggerHeight = newHeight;
      }
    });
    
    // Set heights like in Codepen
    gsap.set([wrapper, cards], {
      height: biggerHeight
    });
  }

  setupTextAnimations(pinnedSection, textContainers, numCards) {
    const texts = Array.from(textContainers).map(container => container.querySelector('h3')).filter(Boolean);
    
    if (texts.length === 0) return;
    
    // Create simple text animations without SplitType
    texts.forEach((text, index) => {
      // Set initial state
      if (index === 0) {
        gsap.set(text, {
          opacity: 1,
          y: 0
        });
      } else {
        gsap.set(text, {
          opacity: 0,
          y: 20
        });
      }
    });
    
    // Create scroll-based text transitions
    this.textScrollTrigger = ScrollTrigger.create({
      trigger: pinnedSection,
      start: 'top center',
      end: `${window.innerHeight * numCards}px`,
      scrub: true,
      onUpdate: ({progress}) => {
        const activeIndex = Math.floor(progress * texts.length);
        
        texts.forEach((text, index) => {
          if (index === activeIndex) {
            gsap.to(text, {
              opacity: 1,
              y: 0,
              duration: 0.5
            });
          } else if (index < activeIndex) {
            gsap.to(text, {
              opacity: 0,
              y: -20,
              duration: 0.3
            });
          } else {
            gsap.to(text, {
              opacity: 0,
              y: 20,
              duration: 0.3
            });
          }
        });
      },
      invalidateOnRefresh: true
    });
  }

  setupNativeAnimation() {
    //console.log('Pinned Animation: Using native animation');
    
    const pinnedSection = this.container.querySelector('.pinned-anim-section');
    const gridCardsWrapper = this.container.querySelector('.grid-cards');
    const gridCards = gridCardsWrapper?.querySelectorAll('.grid-card');
    const textContainers = this.container.querySelectorAll('.text-container');
    
    if (!pinnedSection || !gridCards || gridCards.length === 0) {
      this.setupSimpleFallback();
      return;
    }
    
    const numCards = gridCards.length;
    
    // Setup card heights
    this.setupCardHeightsNative(gridCardsWrapper, gridCards);
    
    let isAnimating = false;
    
    const updateAnimation = () => {
      if (isAnimating) return;
      isAnimating = true;
      
      requestAnimationFrame(() => {
        const sectionRect = pinnedSection.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // Calculate progress exactly like GSAP would
        let progress = 0;
        if (sectionRect.top <= 0 && sectionRect.bottom >= viewportHeight) {
          progress = Math.abs(sectionRect.top) / (sectionRect.height - viewportHeight);
        }
        
        progress = Math.max(0, Math.min(1, progress));
        
        // Apply the EXACT same transform as Codepen
        gridCardsWrapper.style.setProperty('--progress', progress);
        
        // Move individual cards
        const cardHeight = gridCards[0].offsetHeight;
        const cardTranslateY = progress * (numCards - 1) * -100;
        gridCards.forEach(card => {
          card.style.transform = `translateY(${cardTranslateY}%)`;
        });
        
        // Update text visibility
        const activeIndex = Math.floor(progress * numCards);
        textContainers.forEach((container, index) => {
          if (index === activeIndex) {
            container.style.opacity = '1';
            container.style.transform = 'translateY(0)';
          } else {
            container.style.opacity = '0';
            container.style.transform = index < activeIndex ? 'translateY(-20px)' : 'translateY(20px)';
          }
        });
        
        isAnimating = false;
      });
    };
    
    // Throttled scroll handler
    let scrollTimeout;
    this.scrollListener = () => {
      if (scrollTimeout) return;
      
      scrollTimeout = setTimeout(() => {
        updateAnimation();
        scrollTimeout = null;
      }, 16);
    };
    
    this.resizeListener = () => {
      setTimeout(() => {
        this.setupCardHeightsNative(gridCardsWrapper, gridCards);
        updateAnimation();
      }, 100);
    };
    
    // Initial setup
    updateAnimation();
    
    // Add event listeners
    window.addEventListener('scroll', this.scrollListener, { passive: true });
    window.addEventListener('resize', this.resizeListener);
  }

  setupCardHeightsNative(wrapper, cards) {
    if (!wrapper || !cards.length) return;
    
    let maxHeight = 0;
    cards.forEach(card => {
      card.style.height = 'auto';
      const height = card.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });
    
    if (maxHeight > 0) {
      wrapper.style.height = `${maxHeight}px`;
      cards.forEach(card => {
        card.style.height = `${maxHeight}px`;
      });
    }
  }

  setupSimpleFallback() {
    // Simple fallback that just shows the first card and text
    const textContainers = this.container.querySelectorAll('.text-container');
    const gridCardsWrapper = this.container.querySelector('.grid-cards');
    const gridCards = gridCardsWrapper?.querySelectorAll('.grid-card');
    
    if (textContainers.length > 0) {
      textContainers[0].style.opacity = '1';
    }
    
    if (gridCardsWrapper) {
      gridCardsWrapper.style.transform = 'none';
    }
    
    if (gridCards && gridCards.length > 0) {
      gridCards.forEach((card, index) => {
        card.style.transform = index === 0 ? 'translateY(0)' : 'translateY(100%)';
      });
    }
  }

  cleanup() {
    // Kill GSAP animations
    if (typeof gsap !== 'undefined') {
      if (this.cardAnimation) this.cardAnimation.kill();
      if (this.bgAnimation) this.bgAnimation.kill();
      if (this.mainScrollTrigger) this.mainScrollTrigger.kill();
      if (this.textScrollTrigger) this.textScrollTrigger.kill();
    }
    
    // Remove event listeners
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener);
    }
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
    
    this.animationInitialized = false;
  }

  destroy() {
    this.cleanup();
  }
}

// Global registry
const pinnedAnimationRegistry = new Map();

function initializePinnedAnimation(section) {
  const sectionId = section.id || section.dataset.sectionId;
  
  if (!sectionId) {
    console.error('Pinned Animation: Section has no ID');
    return;
  }
  
  // Clean up existing instance
  if (pinnedAnimationRegistry.has(sectionId)) {
    pinnedAnimationRegistry.get(sectionId).destroy();
  }
  
  // Create new instance
  const instance = new PinnedAnimationSection(section);
  pinnedAnimationRegistry.set(sectionId, instance);
  
  return instance;
}

// Initialize all sections
function initializeAllPinnedAnimations() {
  document.querySelectorAll('[data-section-type="pinned-animation"]').forEach((section) => {
    initializePinnedAnimation(section);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllPinnedAnimations);
} else {
  setTimeout(initializeAllPinnedAnimations, 100);
}

// Handle editor events
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="pinned-animation"]');
    if (section) {
      setTimeout(() => initializePinnedAnimation(section), 500);
    }
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="pinned-animation"]');
    if (section) {
      const sectionId = section.id || section.dataset.sectionId;
      if (sectionId && pinnedAnimationRegistry.has(sectionId)) {
        pinnedAnimationRegistry.get(sectionId).destroy();
        pinnedAnimationRegistry.delete(sectionId);
      }
    }
  });
  
  document.addEventListener('shopify:section:select', (event) => {
    const section = event.target.querySelector('[data-section-type="pinned-animation"]');
    if (section) {
      const sectionId = section.id || section.dataset.sectionId;
      if (sectionId && pinnedAnimationRegistry.has(sectionId)) {
        setTimeout(() => {
          pinnedAnimationRegistry.get(sectionId).setupAnimation();
        }, 200);
      }
    }
  });
}

// Handle window resize
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    pinnedAnimationRegistry.forEach(instance => {
      if (instance.animationInitialized) {
        instance.setupAnimation();
      }
    });
  }, 250);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-assets"] && !Shopify.designMode) return;
  try {
    
(function(){var SELECTOR='[data-pp-dp-ast]';function init(root){var scope=root||document;var sections=scope.querySelectorAll?scope.querySelectorAll(SELECTOR):[];Array.prototype.forEach.call(sections,function(section){section.classList.add('is-revealed');var triggers=section.querySelectorAll('[data-asset-trigger]');var imgs=section.querySelectorAll('.pp-dp-ast__preview-img');function setActive(key,btn){Array.prototype.forEach.call(imgs,function(img){img.classList.toggle('is-active',img.getAttribute('data-asset')===key)});Array.prototype.forEach.call(triggers,function(t){t.classList.remove('is-active');t.setAttribute('aria-pressed','false')});if(btn){btn.classList.add('is-active');btn.setAttribute('aria-pressed','true')}}Array.prototype.forEach.call(triggers,function(btn){['mouseenter','focus','click'].forEach(function(ev){btn.addEventListener(ev,function(e){if(ev==='click')e.preventDefault();setActive(btn.getAttribute('data-asset-trigger'),btn)})})})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});document.addEventListener('shopify:section:select',function(e){init(e.target)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-audience"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-aud]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-ben]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-faq]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-frm]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-hero]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-process"] && !Shopify.designMode) return;
  try {
    
(function(){var SELECTOR='[data-pp-dp-prc]';function init(root){var scope=root||document;var sections=scope.querySelectorAll?scope.querySelectorAll(SELECTOR):[];Array.prototype.forEach.call(sections,function(section){section.classList.add('is-revealed');var steps=section.querySelectorAll('.pp-dp-prc-step');var progress=section.querySelector('[data-prc-progress]');function setActive(idx){Array.prototype.forEach.call(steps,function(step,i){step.classList.toggle('is-active',i<=idx)});if(progress){var total=steps.length;var pct=(total>1)?(idx/(total-1))*100:0;progress.style.strokeDashoffset=(100-pct).toString()}}Array.prototype.forEach.call(steps,function(step,i){var node=step.querySelector('.pp-dp-prc-step__node');if(!node)return;['mouseenter','focus','click'].forEach(function(ev){node.addEventListener(ev,function(e){if(ev==='click')e.preventDefault();setActive(i)})})});setActive(0)})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);document.addEventListener('shopify:section:load',function(e){init(e.target)});document.addEventListener('shopify:section:select',function(e){init(e.target)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-support"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-sup]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-designer-partners-why"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-pp-dp-why]';
  var READY = 'is-revealed';
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function reveal(el) {
    if (!el) return;
    if (reduced() || !('IntersectionObserver' in window)) { el.classList.add(READY); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { el.classList.add(READY); io.disconnect(); }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function init(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(nodes, function(node) {
      node.classList.remove(READY);
      requestAnimationFrame(function() { reveal(node); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  document.addEventListener('shopify:section:select', function(e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
